import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'
import { TriggerItem } from './trigger-item'
import { TriggerEdit } from './trigger-edit'
import { toast } from 'react-toastify'

import c from './assets/sass/triggers-list.module.scss'

export const TriggersList = () => {
    const [configs, setConfigs] = useState([])
    const [globalSettings, setGlobalSettings] = useState(null)
    const [stats, setStats] = useState(null)
    const [loading, setLoading] = useState(true)
    const [editingId, setEditingId] = useState(null)
    const [localSettings, setLocalSettings] = useState({})

    useEffect(() => {
        loadAll()
    }, [])

    const loadAll = async () => {
        try {
            const [cfgData, settingsData, statsData] = await Promise.all([
                adminService.getTriggerConfigs(),
                adminService.getTriggerSettings(),
                adminService.getTriggerStats()
            ])
            setConfigs(cfgData.configs || [])
            setGlobalSettings(settingsData.settings)
            setLocalSettings(settingsData.settings || {})
            setStats(statsData.stats)
        } catch (error) {
            console.error('Failed to load triggers:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleSaveGlobal = async () => {
        try {
            await adminService.updateTriggerSettings(localSettings)
            setGlobalSettings(localSettings)
            toast('Глобальные настройки сохранены', { type: 'success' })
        } catch (error) {
            toast('Ошибка: ' + error.message, { type: 'error' })
        }
    }

    if (loading) return <div className={c.loading}>Загрузка...</div>

    if (editingId) {
        return <TriggerEdit configId={editingId} onBack={() => { setEditingId(null); loadAll() }} />
    }

    return (
        <div className={c.component}>
            {globalSettings && (
                <div className={c.globalSettings}>
                    <div className={c.globalHeader}>
                        <span className={c.globalTitle}>Глобальные настройки</span>
                        <label className={c.killSwitch}>
                            <input
                                type="checkbox"
                                checked={localSettings.isEnabled || false}
                                onChange={e => setLocalSettings({ ...localSettings, isEnabled: e.target.checked })}
                            />
                            <span>{localSettings.isEnabled ? 'Система вкл' : 'Система выкл'}</span>
                        </label>
                    </div>
                    <div className={c.settingsGrid}>
                        <div className={c.settingsField}>
                            <label>Макс сообщений / день</label>
                            <input
                                type="number"
                                value={localSettings.maxMessagesPerDay || ''}
                                onChange={e => setLocalSettings({ ...localSettings, maxMessagesPerDay: parseInt(e.target.value) || 1 })}
                                min={1}
                            />
                        </div>
                        <div className={c.settingsField}>
                            <label>Мин интервал (часы)</label>
                            <input
                                type="number"
                                value={localSettings.minIntervalHours || ''}
                                onChange={e => setLocalSettings({ ...localSettings, minIntervalHours: parseInt(e.target.value) || 1 })}
                                min={1}
                            />
                        </div>
                        <div className={c.settingsField}>
                            <label>Тихие часы: начало (МСК)</label>
                            <input
                                type="number"
                                value={localSettings.quietHoursStart ?? ''}
                                onChange={e => setLocalSettings({ ...localSettings, quietHoursStart: parseInt(e.target.value) })}
                                min={0} max={23}
                            />
                        </div>
                        <div className={c.settingsField}>
                            <label>Тихие часы: конец (МСК)</label>
                            <input
                                type="number"
                                value={localSettings.quietHoursEnd ?? ''}
                                onChange={e => setLocalSettings({ ...localSettings, quietHoursEnd: parseInt(e.target.value) })}
                                min={0} max={23}
                            />
                        </div>
                    </div>
                    <button className={c.saveSettingsBtn} onClick={handleSaveGlobal}>
                        Сохранить настройки
                    </button>
                </div>
            )}

            {stats && (
                <div className={c.statsBar}>
                    <div className={c.statItem}>
                        <span className={c.statValue}>{stats.last24h}</span>
                        <span className={c.statLabel}>За 24ч</span>
                    </div>
                    <div className={c.statItem}>
                        <span className={c.statValue}>{stats.last7d}</span>
                        <span className={c.statLabel}>За 7 дней</span>
                    </div>
                    <div className={c.statItem}>
                        <span className={c.statValue}>{stats.totalSent}</span>
                        <span className={c.statLabel}>Всего</span>
                    </div>
                </div>
            )}

            <div className={c.list}>
                {configs.map(cfg => (
                    <TriggerItem
                        key={cfg.id}
                        config={cfg}
                        onEdit={() => setEditingId(cfg.id)}
                        onUpdate={loadAll}
                    />
                ))}
            </div>
        </div>
    )
}
